import { AIMessage } from "@/features/Prompt/schema";
import { getAuthorized } from "@/lib/fetch";

/**
 * Fetches conversation data with comprehensive error handling
 * @param threadId - ID of the thread to fetch
 * @param client - The client identifier
 * @param navigate - React Router navigate function
 * @returns Promise resolving to conversation data or null if error
 */
export const fetchConversationDataWithErrorHandling = async (
  threadId: string,
  client: string,
  path_route: string,
  navigate: (path: string) => void,
): Promise<ReadonlyArray<AIMessage> | null> => {
  try {
    const response = await getAuthorized(
      `${import.meta.env.VITE_BACKEND_URL}/${client}/conversation/${threadId}`,
    );

    if (!response.ok) {
      const status = response.status;

      if (status === 404 || status === 500) {
        console.error("Error fetching conversation:", status);
        navigate(`/${path_route}`);
        return null;
      }

      throw new Error(`HTTP Error: ${status}`);
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching conversation:", error);
    navigate(`/${path_route}`);
    return null;
  }
};
